/* eslint-disable jsx-a11y/media-has-caption */
import { Box, useTheme } from '@material-ui/core';
import useCallAgentPermissionFlags from '@src/hooks/call/useCallAgentPermissionFlags';
import CallEndIcon from '@src/resources/icons/CallEndIcon';
import CallStartIcon from '@src/resources/icons/CallStartIcon';
import { selectHasOngoingCall } from '@src/selectors/calls';
import { useSelector } from 'react-redux';
import IconWrapper from '../Common/IconWrapper';
import LinearProgress from '../Common/LinearProgress';
import RippleAnimation from '../Common/RippleAnimation';
import IconButton from '../UI/IconButton';

type IncomingCallViewProps = {
  isLoadingStartCall: boolean;
  isLoadingEndCall: boolean;
  onStartCall: () => void;
  onEndCall: () => void;
};

const IncomingCallView: React.FC<IncomingCallViewProps> = ({
  isLoadingStartCall,
  isLoadingEndCall,
  onStartCall,
  onEndCall,
}) => {
  const theme = useTheme();
  const hasActiveCall = useSelector(selectHasOngoingCall);

  const { isEnabled } = useCallAgentPermissionFlags();

  return (
    <Box display="flex" style={{ height: 'inherit', width: 38 }}>
      <Box
        component="div"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position="relative"
        height="inherit"
        gridGap={6}
        pl={0.5}
        pr={1.5}
        width="100%"
      >
        <RippleAnimation>
          <IconButton
            size="small"
            style={{ padding: 4 }}
            disabled={hasActiveCall || !isEnabled}
            onClick={() => {
              if (!hasActiveCall) onStartCall();
            }}
            loading={isLoadingStartCall}
          >
            <IconWrapper
              fontSize={22}
              color={theme.b2chatgreen['300']}
              disabled={hasActiveCall}
            >
              <CallStartIcon />
            </IconWrapper>
          </IconButton>
        </RippleAnimation>

        <IconButton
          size="small"
          style={{ padding: 4 }}
          onClick={() => onEndCall()}
          loading={isLoadingEndCall}
        >
          <IconWrapper fontSize={22} color={theme.b2chatred['500']}>
            <CallEndIcon />
          </IconWrapper>
        </IconButton>
      </Box>

      <LinearProgress
        color={theme.b2chatgreen['300']}
        orientation="vertical"
        variant="indeterminate"
      />
    </Box>
  );
};

export default IncomingCallView;
